import { ParentContext } from 'global/cnr/contexts/ParentContext'
import FullPageWrapper from 'global/wrappers/FullPageWrapper'
import { ModifySeasonMatches } from 'projectSpecific/sports/create/ModifySeasonMatches'
import { useContext } from 'react'

export const ModifyTeamMatches = ({ handleCancel }) => {

  const parentContext = useContext(ParentContext);
  const { states } = parentContext ?? {}
  const { paps_state } = states
  const { pathViews } = paps_state ?? {}

  return <FullPageWrapper
    topperCaption={'Team Schedule'}
    content={<ModifySeasonMatches teamKey={pathViews.teams} />}
    handleCancel={handleCancel}
    css={{ container: 'app-dark-mode' }}
  ></FullPageWrapper>

}
